import { Cores, Corpo } from "@componentes-mu/componentes-mu";

export interface TabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label: string;
    index: number;
}

export const Tab = ({ label, index, ...props }: TabProps) => {
    const isSelected = props["aria-selected"];

    const tabStyle: React.CSSProperties = {
        padding: '12px 16px',
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        borderBottom: isSelected ? '4px solid #43A4D1' : '2px solid transparent',
        transition: 'all 0.3s ease-in-out',
        outline: 'none',
    };

    return (
        <button
            role="tab"
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
            style={tabStyle}
            {...props}
        >
            <Corpo
                tipo={isSelected ? "label1" : "label2"}
                negrito={700}
                cor={
                    isSelected
                        ? Cores.GradacaoNeutros.PretoMU900
                        : Cores.GradacaoNeutros.CinzaFillMU500
                }
                style={{ cursor: 'inherit' }}
            >
                {label.toUpperCase()}
            </Corpo>
        </button>
    );
};

